import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import {
  ProofOfPerformance2PDCReport,
  proofOfPerformance2PDCReportSchema,
} from '@sophocles/entities/ProofOfPerformance2PDCReport/record';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { produce } from 'immer';

export const RECEIVE_PROOF_OF_PERFORMANCE_2PDC_REPORTS = 'RECEIVE_PROOF_OF_PERFORMANCE_2PDC_REPORTS';
function receiveProofOfPerformance2PDCReports(json) {
  return {
    type: RECEIVE_PROOF_OF_PERFORMANCE_2PDC_REPORTS,
    proofOfPerformance2PDCReports: mapListToRecords(json, ProofOfPerformance2PDCReport),
  };
}

/* Fetch Actions */
// starter fetch

export function fetch2PDCProofOfPerformanceReports(siteId, queryParams) {
  const params = { site: siteId, ...queryParams };
  return dispatch => {
    return apiClient
      .get('/reports/daily-2pdc-pop/', {
        params,
      })
      .then(checkHttpStatus)
      .then(response => {
        const normalized = normalizeList(
          response.data.results,
          'proofOfPerformance2PDCReports',
          proofOfPerformance2PDCReportSchema,
        );
        dispatch(receiveProofOfPerformance2PDCReports(normalized.entities.proofOfPerformance2PDCReports));
        return produce(response.data, draft => {
          for (let i = 0; i < draft.results.length; i++) {
            draft.results[i].passFail = draft.results[i].passed ? 'PASS' : 'FAIL';
          }
          return draft;
        });
      })
      .catch(error => {
        dispatch(genericErrorAction(error, 'REQUEST_SITE_PROOF_OF_PERFORMANCE_REPORT'));
      });
  };
}

export function fetch2PDCProofOfPerformanceRollupReports(siteGroupId, queryParams) {
  const params = { site_group: siteGroupId, ...queryParams };
  return dispatch => {
    return apiClient
      .get('/reports/daily-2pdc-pop/', {
        params,
      })
      .then(checkHttpStatus)
      .then(response => {
        const normalized = normalizeList(
          response.data.results,
          'proofOfPerformance2PDCReports',
          proofOfPerformance2PDCReportSchema,
        );
        dispatch(receiveProofOfPerformance2PDCReports(normalized.entities.proofOfPerformance2PDCReports));
        return response.data;
      })
      .catch(error => {
        dispatch(genericErrorAction(error, 'REQUEST_SITE_PROOF_OF_PERFORMANCE_REPORT'));
      });
  };
}
